import { TreeList } from '@ibsys/kit';
import { useSortable } from '@dnd-kit/react/sortable';
import { FileTextIcon, GripVerticalIcon } from 'lucide-react';
import { FC } from 'react';
import { cn } from '@/shared/lib';
import type { CompetencyResponse } from '@/entities/coaching';

type LeafNodeProps = {
  competency: CompetencyResponse;
  /** Порядковый номер в списке сортировки */
  index: number;
  onSelect: (id: number) => void;
};

export const LeafNode: FC<LeafNodeProps> = ({ competency, index, onSelect }) => {
  const sortableId = `competency-${competency.id}`;
  const { ref, handleRef, isDragging } = useSortable({ id: sortableId, index });

  return (
    <div ref={ref} className={cn(isDragging && 'opacity-50')}>
    <TreeList.Item
      value={String(competency.id)}
      onClick={() => onSelect(competency.id)}
      className="group/leaf"
    >
      <div className="flex items-center gap-2 w-full">
        <FileTextIcon size={14} className="shrink-0 text-muted-foreground" />
        <span className="line-clamp-2 flex-1 text-left text-sm font-medium leading-tight">{competency.name}</span>
        {/* Перетаскивание */}
        <div
          className="shrink-0 cursor-grab text-muted-foreground opacity-0 transition-opacity group-hover/leaf:opacity-100 ml-auto"
          ref={(el) => handleRef(el)}
          onClick={(e) => e.stopPropagation()}
        >
          <GripVerticalIcon size={14} />
        </div>
      </div>
    </TreeList.Item>
    </div>
  );
};
